<template>
  <main class="error" style="opacity: 0;">
    <section class="error__video">
      <div class="error__video__title">
        <h3 data-anim="title" data-view="false" v-html="translate('ERROR_TITLE', $store.state.lang)"></h3>
      </div>
      <video
        data-anim="fade"
        data-view="false"
        loop autoplay muted playsinline ref="video"
        @click="toggleAudio">
        <source src="https://player.vimeo.com/external/339929073.sd.mp4?s=be3135908fc7451ffcc891a5b9fc0d3e75c7c87b&profile_id=164" type="video/mp4">
      </video>
      <div class="error__video__volume">
        <p
          data-anim="fade"
          data-view="false"
        >
          <span v-show="mute" v-html="translate('VIDEO_VOLUME', $store.state.lang)" />
          <span v-show="!mute" v-html="translate('VIDEO_MUTE', $store.state.lang)" />
        </p>
      </div>
    </section>
    <section class="error__cta">
      <a
        :href="`/${$store.state.lang}`"
        data-anim="fade"
        data-view="false"
      >
        <bdi v-html="translate('GO_BACK', $store.state.lang)">
        </bdi>
      </a>
    </section>
  </main>
</template>

<script>
import translate from '@/assets/i18n/';

export default {
  name: 'Error404',

  data() {
    return {
      translate,
      mute: true,
    };
  },

  methods: {
    toggleAudio() {
      const video = this.$refs.video;
      this.mute = !this.mute;
      video.muted = !video.muted;
    },
  },
};
</script>

<style lang="scss" scoped>
.error {
  position: relative;
  padding: 0;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;

  padding-top: rem(180px);

  &__cta {
    position: relative;
    width: 100%;
    text-align: center;

    a {
      display: inline-block;
    }
  }

  &__video {
    position: relative;
    height: calc(var(--vh, 1vh) * 50);

    cursor: pointer;

    &__title {
      position: absolute;
      z-index: 1;
      text-align: center;
      width: 100%;
      top: 50%;

      transform: translate3d(0, -50%, 0);

      h3 {
        @include fluid-type(375px, 1920px, 36px, 50px, 40px, 60px);
        color: $color-bg;
      }
      pointer-events: none;
    }

    &__volume {
      position: absolute;
      width: 100%;
      text-align: center;
      bottom: rem(10px);
      color: $color-bg;

      pointer-events: none;
    }

    video {
      position: relative;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
}
</style>
